import { hours as Hours } from '@harvesthq/clockwork'
import moment from 'moment'

const { parseFloat } = Number

const SERVER_UTC_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSZ'
const SERVER_TIMESTAMP_FORMAT = 'ddd, D MMM YYYY HH:mm:ss ZZ'
const SERVER_TIME_FORMAT = 'ddd, D MMM YYYY HH:mm:ss'
const API_UTC_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ'

const FORMATS = [
  'hh:mm a',
  'hh:mma',
  'h:mm a',
  'h:mma',
  'hh:m a',
  'hh:ma',
  'HH:mm',
  'h:ma',
  'H',
  'Ha',
  'H a',
  'H:m',
  'H.m',
  'HH:m',
  'H:mm',
  'hhmm',
  'HHmm',
  'YYYY-MM-DD hh:mm a',
  SERVER_UTC_FORMAT,
  SERVER_TIMESTAMP_FORMAT,
  SERVER_TIME_FORMAT,
  API_UTC_FORMAT,
]

export function toMoment(raw) {
  const parsed = moment(raw, FORMATS, true)
  if (parsed.isValid()) {
    return parsed
  }

  return undefined
}

export function toDuration(raw) {
  if (!raw) return

  if (raw.includes(':')) {
    if (raw.startsWith(':')) {
      raw = `0${raw}`
    }
    return moment.duration(raw)
  }

  const minutes = parseFloat(raw.replace(',', '.')) * 60
  return moment.duration(Math.round(minutes), 'minutes')
}

export function formattedTime(time) {
  return Hours.localize(Hours.to_hhmm(time), {
    force_two_digits: true,
  })
}
